import React, { Component }        from 'react';
import { withRouter }              from 'react-router';
import { connect as reduxConnect } from 'react-redux';
import PubSub                      from 'pubsub-js';
import { redirect }                from '../../../../utils/authService'; 
import { isLoggedIn }              from '../../../../utils/authService';
import SplashLogo                  from '../../../../images/boisestate-primarylogo.svg';

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      splash    : false,
      isDesktop	: false
    };
    
    this.handleAnonymousForm = this.handleAnonymousForm.bind(this);
    this.login               = this.login.bind(this);
    this.updatePredicate     = this.updatePredicate.bind(this);
  }
  
  componentWillUnmount(){
    window.removeEventListener('resize', this.updatePredicate); 
  }

  componentDidMount() {  
    if (!isLoggedIn()) {
      this.setState({
        splash: true
      });
      
      window.addEventListener("resize", this.updatePredicate);
      this.updatePredicate(); 
    }
  }
  
  ////////////////////////
  // KEY/HELPER METHODS //
  ////////////////////////
  
  login() {
    redirect(window.location.hash.replace("#/", ""));
  }
  
  handleAnonymousForm() {
    this.setState({
      splash: false
    }, function() {
      PubSub.publish('connect.chat.ui.stateChange', {
        form: true
      });
    });
  }
  
  updatePredicate() {
    this.setState({ isDesktop: window.innerWidth > 1250 });
  }

  render() {
    const isDesktop = this.state.isDesktop;
    return (
      <div>
        {
          this.state.splash ?
          <div>
            <img className='center' height='50%' width='50%' src={SplashLogo} alt="Boise State University" />
	          <br></br><br></br>
            <center>
              { isDesktop ? 
                (
		              <a href={window.location.href} className="c-btn c-btn--sm" style={{ width: '50%', lineHeight: 0, marginTop: '10px' }} onClick={this.login}>
                    <span className="c-btn__text">Use my Boise State login to chat</span>
                  </a>
	              ) : 
                (
		              <a href={window.location.href} className="c-btn c-btn--sm" style={{ width: '100%', lineHeight: 0, marginTop: '10px' }} onClick={this.login}>
                    <span className="c-btn__text">Use my Boise State login to chat</span>
                  </a>
	              )
              }
            </center>
            <center>
	            { isDesktop ? 
                (
		              <a href={window.location.href} className="c-btn c-btn--sm" style={{ width: '50%', lineHeight: 0, marginTop: '10px', marginBottom: '10px' }} onClick={this.handleAnonymousForm}>
                    <span className="c-btn__text">I want to chat as a Guest</span>
                  </a>
                ) : 
                (
		              <a href={window.location.href} className="c-btn c-btn--sm" style={{ width: '100%', lineHeight: 0, marginTop: '10px', marginBottom: '10px' }} onClick={this.handleAnonymousForm}>
                    <span className="c-btn__text">I want to chat as a Guest</span>
                  </a>
	              )
              }
	          </center>
          </div>
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(Splash));
